var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
      },
      _vm.$listeners
    ),
    [
      _c("circle", { attrs: { cx: "12", cy: "8", r: "6", fill: "#63E1E7" } }),
      _c("path", {
        attrs: {
          d: "M12 4v17M4 9h16M12 9c2.5 4.5 4.8 7.1 8 9.5M12 9c-2.5 4.5-4.8 7.1-8 9.5",
          stroke: "#2C3143",
          "stroke-width": "2",
          "stroke-linecap": "round",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }